(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glowwa-article-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.glowwa-article-content__share-copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          var section = btn.closest('.glowwa-article-content__share');
          if (!section) return;
          var toast = section.querySelector('.glowwa-article-content__copy-toast');
          if (!toast) return;
          toast.textContent = 'Link copied!';
          toast.classList.add('is-visible');
          clearTimeout(btn._copyTimer);
          btn._copyTimer = setTimeout(function () {
            toast.classList.remove('is-visible');
            toast.textContent = '';
          }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowwa-blog-listing"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.glowwa-blog-listing-section');
  if (section) {
    section.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-load-more]');
      if (!btn) return;

      e.preventDefault();

      const url = btn.getAttribute('href');
      const grid = section.querySelector('[data-blog-grid]');
      const countEl = section.querySelector('[data-article-count]');

      btn.textContent = 'Loading...';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.6';

      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Append new cards
          doc.querySelectorAll('[data-blog-grid] .glowwa-blog-listing__card-wrap').forEach((card) => {
            grid.appendChild(card);
          });

          // Update or remove the Load More button
          const nextBtn = doc.querySelector('[data-load-more]');
          if (nextBtn) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.textContent = 'Load More';
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          } else {
            btn.remove();
          }

          // Update count text
          const nextCount = doc.querySelector('[data-article-count]');
          if (nextCount && countEl) {
            countEl.textContent = nextCount.textContent;
          }
        })
        .catch(() => {
          btn.textContent = 'Load More';
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-loop-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function wireLoopCarousel(section) {
      if (!section) return false;
      var slideshowId = section.getAttribute('data-hw-loop-slideshow-id');
      var slideshow = section.querySelector('[data-slideshow-id="' + slideshowId + '"]');
      if (!slideshow || typeof slideshow.next !== 'function') return false;

      var nav = section.querySelector('.hw-carousel-navigation');
      if (nav) {
        var arrows = nav.querySelectorAll('button[ref="previous"], button[ref="next"]');
        if (arrows.length === 0) {
          arrows = nav.querySelectorAll('.hw-carousel-navigation__control[ref="previous"], .hw-carousel-navigation__control[ref="next"], .slideshow-control[ref="previous"], .slideshow-control[ref="next"]');
        }

        arrows.forEach(function(btn) {
          var ref = btn.getAttribute('ref');
          if (ref === 'previous' || ref === 'next') {
            btn.removeAttribute('on:click');
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (ref === 'next') slideshow.next(e); else slideshow.previous(e);
            }, true);
          }
        });
      }
      section.setAttribute('data-hw-loop-wired', 'true');
      return true;
    }

    var tryCount = 0;
    var maxTries = 100;
    function tryWire() {
      var sections = Array.prototype.slice.call(
        document.querySelectorAll('[data-hw-loop-slideshow-id]')
      );
      if (!sections.length) return;
      var pending = 0;
      sections.forEach(function(section) {
        if (section.getAttribute('data-hw-loop-wired') === 'true') return;
        if (!wireLoopCarousel(section)) {
          pending++;
        }
      });
      if (pending === 0) return;
      tryCount++;
      if (tryCount >= maxTries) return;
      if (typeof customElements !== 'undefined' && customElements.whenDefined) {
        customElements.whenDefined('slideshow-component').then(function() {
          setTimeout(function() {
            tryWire();
          }, 0);
        });
      } else {
        setTimeout(tryWire, 50);
      }
    }
    function start() {
      tryWire();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(start, 0); });
    } else {
      setTimeout(start, 0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-loop-material"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function wireLoopCarousel(section) {
      if (!section) return false;
      var slideshowId = section.getAttribute('data-hw-loop-slideshow-id');
      var slideshow = section.querySelector('[data-slideshow-id="' + slideshowId + '"]');
      if (!slideshow || typeof slideshow.next !== 'function') return false;

      var nav = section.querySelector('.hw-carousel-navigation');
      if (nav) {
        var arrows = nav.querySelectorAll('button[ref="previous"], button[ref="next"]');
        if (arrows.length === 0) {
          arrows = nav.querySelectorAll('.hw-carousel-navigation__control[ref="previous"], .hw-carousel-navigation__control[ref="next"], .slideshow-control[ref="previous"], .slideshow-control[ref="next"]');
        }

        arrows.forEach(function(btn) {
          var ref = btn.getAttribute('ref');
          if (ref === 'previous' || ref === 'next') {
            btn.removeAttribute('on:click');
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (ref === 'next') slideshow.next(e); else slideshow.previous(e);
            }, true);
          }
        });
      }
      section.setAttribute('data-hw-loop-wired', 'true');
      return true;
    }

    var tryCount = 0;
    var maxTries = 100;
    function tryWire() {
      var sections = Array.prototype.slice.call(
        document.querySelectorAll('[data-hw-loop-slideshow-id]')
      );
      if (!sections.length) return;
      var pending = 0;
      sections.forEach(function(section) {
        if (section.getAttribute('data-hw-loop-wired') === 'true') return;
        if (!wireLoopCarousel(section)) {
          pending++;
        }
      });
      if (pending === 0) return;
      tryCount++;
      if (tryCount >= maxTries) return;
      if (typeof customElements !== 'undefined' && customElements.whenDefined) {
        customElements.whenDefined('slideshow-component').then(function() {
          setTimeout(function() {
            tryWire();
          }, 0);
        });
      } else {
        setTimeout(tryWire, 50);
      }
    }
    function start() {
      tryWire();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(start, 0); });
    } else {
      setTimeout(start, 0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-octane-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-testid="hw_octane_quiz"]');

    if (!sections.length) return;

    /**
     * Hero "Start the quiz" uses href="#quiz". Native hash scroll pins the
     * section to the top of the viewport; center it instead. Only intercepts
     * links whose hash matches this section's id — no global scroll changes.
     */
    const quizAnchorIds = new Set(
      [...sections].map((section) => section.id).filter(Boolean),
    );

    if (quizAnchorIds.size) {
      document.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('a[href^="#"]');

          if (!link) return;

          const hash = link.getAttribute('href');

          if (!hash || hash.length < 2) return;

          const id = decodeURIComponent(hash.slice(1));

          if (!quizAnchorIds.has(id)) return;

          const target = document.getElementById(id);

          if (!target) return;

          event.preventDefault();

          const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
          ).matches;

          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'instant' : 'smooth',
            block: 'center',
          });

          history.replaceState(null, '', hash);
        },
        true,
      );
    }

    const roots = document.querySelectorAll('[data-testid="hw_octane_quiz"] [data-quiz-id]');

    if (!roots.length) return;

    /**
     * Capitalize the first letter of a text node without touching the rest.
     * @param {string} value
     * @returns {string}
     */
    const toSentenceCase = (value) =>
      value.replace(/^(\s*)(\p{L})/u, (_, space, letter) => `${space}${letter.toUpperCase()}`);

    /**
     * @param {ParentNode} root
     */
    const applySentenceCase = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue || !/\p{L}/u.test(node.nodeValue)) {
            return NodeFilter.FILTER_REJECT;
          }

          const parent = node.parentElement;

          if (!parent) return NodeFilter.FILTER_REJECT;
          if (parent.closest('script, style, svg, noscript')) {
            return NodeFilter.FILTER_REJECT;
          }
          if (parent.closest('[data-content-section="watermark"], a[href*="octaneai.com"]')) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        },
      });

      const nodes = [];

      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }

      for (const node of nodes) {
        const next = toSentenceCase(node.nodeValue);

        if (next !== node.nodeValue) {
          node.nodeValue = next;
        }
      }
    };

    /**
     * Octane fullpage embeds call scrollToTop() on every step when
     * styling.layout.enabled_autoscroll is true. That smooth-scrolls the
     * window to the quiz container (looks like #quiz re-anchoring).
     * Prefer Design → Layout → Autoscroll off in Octane; this is the
     * theme-side escape hatch for page embeds with content above/below.
     * @returns {boolean}
     */
    const disableOctaneAutoscroll = () => {
      const quizController = window.lastQuizController;

      if (!quizController) return false;
      if (quizController.__hwAutoscrollDisabled) return true;

      if (quizController.styling?.layout) {
        quizController.styling.layout.enabled_autoscroll = false;
      }

      if (typeof quizController.scrollToTop === 'function') {
        quizController.scrollToTop = () => {
          if (quizController.styling?.layout) {
            quizController.styling.layout.enabled_autoscroll = false;
          }
        };
      }

      quizController.__hwAutoscrollDisabled = true;
      return true;
    };

    if (!disableOctaneAutoscroll()) {
      const startedAt = Date.now();
      const timer = setInterval(() => {
        if (disableOctaneAutoscroll() || Date.now() - startedAt > 20000) {
          clearInterval(timer);
        }
      }, 100);
    }

    /**
     * Regular (non-salon) quiz only: swap the product recommendation's
     * "View Product" button for a real Add to Cart button that adds the
     * bundle via the AJAX Cart API and opens the cart drawer, instead of
     * navigating to the product page. Salon quiz keeps its "speak to your
     * stylist" behaviour (button hidden entirely, see glowwa-quiz-results.css)
     * so this is scoped tightly to the regular quiz's ID and fails safe —
     * if a variant id can't be found the button is left untouched.
     */
    const REGULAR_QUIZ_ID = '5Ngs15diHhcvVtyu';
    const ADD_TO_CART_LABEL = 'Add to Cart';

    /**
     * @param {Element} productBlock
     * @returns {string | null}
     */
    const getRecommendedVariantId = (productBlock) => {
      const resultItem = productBlock.closest('[data-element="oct-quiz-resultitem"]') || productBlock;
      const link = resultItem.querySelector('a[href*="variant="]');

      if (!link) return null;

      const match = link.getAttribute('href')?.match(/[?&]variant=(\d+)/);

      return match ? match[1] : null;
    };

    /**
     * @param {string} variantId
     * @param {HTMLButtonElement} button
     */
    const addQuizRecommendationToCart = async (variantId, button) => {
      if (button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        // Mirrors the theme's own product-form add-to-cart dispatch (see
        // assets/product-form.js) so the cart drawer (auto-open), cart icon
        // count, and cart line items all update exactly as they would from a
        // normal PDP add-to-cart.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'octane-quiz-add-to-cart',
              data: {
                source: 'product-form-component',
                itemCount: data.quantity || 1,
                variantId: data.variant_id,
                sections: data.sections,
              },
            },
          }),
        );
      } catch (error) {
        console.error('[Octane quiz] Add to cart failed:', error);
      } finally {
        button.textContent = originalText;
        button.disabled = false;
      }
    };

    /**
     * @param {Element} root
     */
    const wireQuizAddToCart = (root) => {
      if (root.getAttribute('data-quiz-id') !== REGULAR_QUIZ_ID) return;

      const productBlocks = root.querySelectorAll('[data-element*="oct-quiz-productblock"]');

      for (const block of productBlocks) {
        const button = block.querySelector('button');

        if (!button || button.dataset.hwAddToCartWired === 'true') continue;

        const variantId = getRecommendedVariantId(block);

        if (!variantId) continue;

        button.dataset.hwAddToCartWired = 'true';
        button.textContent = ADD_TO_CART_LABEL;

        button.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            addQuizRecommendationToCart(variantId, button);
          },
          true,
        );
      }
    };

    for (const root of roots) {
      applySentenceCase(root);
      wireQuizAddToCart(root);

      const observer = new MutationObserver(() => {
        disableOctaneAutoscroll();
        applySentenceCase(root);
        wireQuizAddToCart(root);
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
